import React from "react";

// css
import "./style.css";

export interface IInputProps {
  inputName?: string;
  inputType?: string;
  inputPlaceholder?: string;
  rules?: object;
  register?: any;
  iconName?: string;
  disabled?: boolean;
  id?: string;
  className?: string;
  label?: any;
  handleClick?: any;
  handleIconClick?: () => void;
  minDate: any;
  keyPressHandler?: (e: any) => void;
  readOnly?: boolean;
}
const defaultClick = () => {};
const disablePastDate = () => {
  const today = new Date();
  const dd = String(today.getDate() + 1).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  return yyyy + "-" + mm + "-" + dd;
};
const defaultProps: IInputProps = {
  className: "",
  register: {},
  inputName: "",
  handleClick: defaultClick,
  inputPlaceholder: "",
  inputType: "",
  rules: {},
  iconName: "",
  handleIconClick: defaultClick,
  disabled: false,
  label: "",
  id: "",
  minDate: disablePastDate,
  keyPressHandler: defaultClick,
  readOnly: false,
  
};
export default function InputComponent(props: IInputProps) {
  const {
    register,
    handleClick,
    inputName,
    inputPlaceholder,
    inputType,
    rules,
    iconName,
    handleIconClick,
    disabled,
    id,
    keyPressHandler,
    className = "",
    label = "",
    minDate,
    readOnly,
    ...rest

  } = props;
  return (
    <div className="input-control">
      <input
        type={inputType}
        onClick={handleClick}
        min={minDate}
        disabled={disabled}
        className={className === "" ? `form-control` : className}
        placeholder={inputPlaceholder}
        readOnly={readOnly}
        onWheel={(e) => {
          e.currentTarget.blur();
        }}
        onKeyDown={keyPressHandler}
        id={id}
        {...register(inputName, rules)}
        {...rest}
      />
      {label}
      {iconName !== "" && (
        <span className="icon-group">
          <button
            type="button"
            id="show_password01"
            name="show_password"
            className="icon-button"
            onClick={handleIconClick}
          >
            <img
              alt="password-icon"
              src={iconName}
              className="togglePassword"
            />
          </button>
        </span>
      )}
    </div>
  );
}
InputComponent.defaultProps = defaultProps;
